(function() {
  'use strict';

  angular.module('component.dashboardTemplates')
    .component('dashboardTemplatesList', {
      templateUrl: 'app/components/dashboard-templates/list.html',
      controller: 'DashboardTemplatesController',
      controllerAs: 'templatesListCtrl'
    })
    .component('dashboardTemplateForm', {
      templateUrl: 'app/components/dashboard-templates/form.html',
      controller: 'DashboardTemplateController',
      controllerAs: 'templateFormCtrl',
      bindings: {
        id: '<'
      }
    })
    .component('dashboardTemplatesReorder', {
      templateUrl: 'app/components/dashboard-templates/list-reorder.html',
      controller: 'DashboardReorderController',
      controllerAs: 'templateReorderCtrl'
    });
})();
